import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select-icon",
  "use": "icon-select-icon-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-select-icon\">\r\n    <path id=\"icon-select-icon_gou\" d=\"M81,74a7,7,0,1,1-7-7A7,7,0,0,1,81,74Zm-2.561-1.845-1.1-1.1L73.1,75.3l-2.437-2.437-1.1,1.1L73.1,77.5Z\" transform=\"translate(-67 -67)\" fill=\"#70c050\" />\r\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol